import type { HelpFile } from '../../types/help'
import { LlmPromptDetailTestIds } from '../../../testids/LlmPromptDetailTestIds'

export const llmPromptDetailHelp: HelpFile = {
  docPage: '/docs/admin/llm-prompts',
  texts: {
    [LlmPromptDetailTestIds.llmPromptDetailPage]:
      'LLM-Prompt-Vorlage bearbeiten — Metadaten einsehen, Prompt-Text anpassen und live gegen das Modell testen.',
    [LlmPromptDetailTestIds.cardLlmPromptMetadata]:
      'Metadaten zu diesem Prompt — Schlüssel, Modell, zugeordnetes Modul und Beschreibung.',
    [LlmPromptDetailTestIds.cardTitlePromptEditor]:
      'Prompt-Text bearbeiten — Variablen in {{doppelten Klammern}} werden zur Laufzeit ersetzt.',
    [LlmPromptDetailTestIds.cardTitleTestPanel]:
      'Gerenderten Prompt mit Beispieldaten an das LLM senden und Ergebnis prüfen.',
    [LlmPromptDetailTestIds.llmPromptEditor]:
      'Quelltext-Editor für den Prompt — über „Vorschau rendern" die Variablenersetzung prüfen.',
    [LlmPromptDetailTestIds.llmPromptTextarea]: null,
    [LlmPromptDetailTestIds.llmPromptVariables]:
      'Variablennamen, die der Prompt referenziert — Werte im Testbereich angeben, um eine Vorschau zu rendern.',
    [LlmPromptDetailTestIds.renderedPromptPreview]:
      'Vorschau des Prompts nach Variablenersetzung — genau dieser Text wird an das Modell gesendet.',
    [LlmPromptDetailTestIds.llmTestResponse]:
      'Antwort des LLM auf den letzten Testlauf.',
    [LlmPromptDetailTestIds.inputTestRequest]:
      'Beispiel-Anfrage zum Rendern des Prompts und Aufruf des LLM.',
    [LlmPromptDetailTestIds.btnSavePrompt]: null,
    [LlmPromptDetailTestIds.btnCancelPrompt]: null,
    [LlmPromptDetailTestIds.btnRenderPreview]:
      'Prompt mit den angegebenen Testvariablen rendern, um den endgültigen Text zu prüfen.',
    [LlmPromptDetailTestIds.btnRestoreDefault]:
      'Prompt-Text auf den ausgelieferten Standard zurücksetzen — lokale Änderungen gehen dabei verloren.',
    [LlmPromptDetailTestIds.btnSendToLlm]: null,
    [LlmPromptDetailTestIds.btnToggleTestPanel]: null,
    [LlmPromptDetailTestIds.dialogRestoreDefault]:
      'Zurücksetzen auf den Standard bestätigen — lokale Änderungen gehen dabei verloren.',
  },
}
